/**
 * According to Matt McCabe from the API team,
 * the pricing endpoint treats code 3930 and 3925 as vip,
 * all other codes are treated as lead, see full doc of the codes:
 * https://confluence.techstyle.net/display/API/Status+Codes.+ALL+OF+THEM
 * */
export const MEMBERSHIP_STATUS = {
  VIP: 3930,
  PROSPECTIVE: 3926,
};
